import axios from "axios";
import {SET_USR_DETAILS,SET_DOC_DETAIL,SET_APPOINTMENT,SET_APPOINTMENT_LIST ,SET_ISAPPOINTMENT_SLOT_OPEN,SET_APPOINTMENT_COUNTS, OPEN_LOGIN_MODAL, CLOSE_LOGIN_MODAL,OPEN_SIGNUP_MODAL, CLOSE_SIGNUP_MODAL} from "./reducer";
import { decryptData } from "../Services/TabServices";

const patientId = sessionStorage.getItem('userId');
const userType = sessionStorage.getItem('userType');
const token = sessionStorage.getItem('token');

// axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
export const setPatientDetails = (token:any,userId:any) => async (dispatch: any) => {
  let tokenToUse = token || sessionStorage.getItem("token");
  let patientId;
  
  if (userId) {
    // Use passed userId (from registration)
    patientId = userId;
  } else {
    // Decrypt from sessionStorage (from login/stored session)
    const storedUserId = sessionStorage.getItem('userId');
    patientId = storedUserId ? decryptData(storedUserId):null;
  }

  if (!patientId || !tokenToUse) {
    console.error("Missing patientId or token");
    return;
  }
  try {
    const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/GetPatientDetailsById`, 
        {
          headers: {
            Authorization: `Bearer ${tokenToUse}`,
        },
            params: { PatientId: patientId}
        }
    );
    const patientdetails = response.data;
    dispatch({
      type: SET_USR_DETAILS,
      payload: patientdetails, 
    });
  } catch (error) {
    console.error("Error fetching patientdetails:", error);
  }
};

export const setDoctorDetails = (doctorId:any) => async (dispatch: any)=>{
//   const storedUserId = sessionStorage.getItem("userId");
//     const userType = sessionStorage.getItem("userType");
// const DrId =storedUserId && userType === "D"? decryptData(doctorId) : doctorId;
 
  try {
    const response = await axios.get(
    
        `${process.env.REACT_APP_BASE_URL}/api/Patient/GetDoctorById`, 
        {
            params: { DrId: doctorId} 
        }
    );
    const doctordetails = response.data;
   
    dispatch({
      type: SET_DOC_DETAIL,
      payload: doctordetails,
    });
  } catch (error){
    console.error("Error fetching DOCTOR DETAIL:", error);
  }
};
export const isAppointmentslotOpen=(type:any)=>(dispatch:any)=>{
  dispatch({
    type:SET_ISAPPOINTMENT_SLOT_OPEN,
    payload:type
  })
}
export const setAppointment=(appDetail:any)=>(dispatch:any)=>{
  dispatch({
    type:SET_APPOINTMENT,
    payload:appDetail
  })
}


export const setAppointmentList = () => async (dispatch: any) => {
  try {
    const token = sessionStorage.getItem("token");
    const storedUserId = sessionStorage.getItem("userId");
  const patientId = storedUserId ? decryptData(storedUserId) : null;
    if (!token || !patientId) return;

    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/Patient/GetPatientAppointmentDetailsByPId`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { PatientId: patientId },
      }
    );

    const rawAppointments = response.data;
    const now = new Date();

    const formattedAppointments = rawAppointments.map((item: any) => {
      const appointmentDateTime = new Date(`${item.appointmentDate}T${item.slotStartTime}`);

      const formatedTime = appointmentDateTime.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      const formatedDate = appointmentDateTime.toLocaleDateString("en-US", {
        day: "2-digit",
        month: "short",
      });

      return {
        ...item,
        formatedTime,
        formatedDate,
        appointmentDateTime, // store for sorting
      };
    });

    //  Sort all appointments by date (ascending)
    const sortedAppointments = formattedAppointments.sort(
      (a: any, b: any) => new Date(b.appointmentDateTime).getTime() - new Date(a.appointmentDateTime).getTime()
    );

    const upAppointments = sortedAppointments.filter((item: any) => {
      const appointmentEnd = new Date(`${item.appointmentDate}T${item.slotEndTime}`);
      return appointmentEnd >= now;
    });

    const pAppointments = sortedAppointments.filter((item: any) => {
      const appointmentEnd = new Date(`${item.appointmentDate}T${item.slotEndTime}`);
      return appointmentEnd < now;
    });

    dispatch({
      type: SET_APPOINTMENT_LIST,
      payload: {
        upcomingAppointments: upAppointments,
        pastAppointments: pAppointments,
      },
    });
  } catch (error) {
    console.error("Error fetching appointments:", error);
  }
};

export const setAppointmentCounts = (newCounts: any) => (dispatch: any) => {
  dispatch({
    type: SET_APPOINTMENT_COUNTS,
    payload: newCounts,
  });
};
export const openLoginModal = () => ({
  type: OPEN_LOGIN_MODAL,
});

export const closeLoginModal = () => ({
  type: CLOSE_LOGIN_MODAL,
});

export const openSignupModal = () => ({
  type: OPEN_SIGNUP_MODAL,
});

export const closeSignupModal = () => ({
  type: CLOSE_SIGNUP_MODAL,
});

